import { ChangeEventHandler, useRef } from "react";
// import { getInitials } from "../../../src/Custom hooks/helpers";
import styles from "./style.module.css";
import { ReactComponent as AttachPinSvg } from "../../../../../assets/attachpin.svg";

interface Props {
  edit?: boolean;
  src?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  btnText: string;
  fallback?: string;
  accept?: string;
  imageUpload: string[];
}

const NewTicketImageTemp = ({
  edit,
  src,
  onChange,
  btnText,
  fallback,
  accept,
  imageUpload,
}: Props) => {
  const imageRef = useRef<HTMLInputElement>(null);
  return (
    <div className={styles.container}>
      {imageUpload.length < 2 && (
        <div
          className={styles.imageContainer}
          onClick={() => imageRef.current && imageRef.current.click()}
        >
          <div className={styles.placeholder}>
            <div className={styles.inner}>
              <p>Attach</p>
              <AttachPinSvg />
            </div>
          </div>
        </div>
      )}
      {!edit && (
        <>
          <input
            hidden
            ref={imageRef}
            type="file"
            accept={accept ? accept : "image/jpeg"}
            onChange={onChange}
          />
          {/* TODO accept only jpeg file. Should convert or warn? */}
          {/* <button
            type="button"
            onClick={() => imageRef.current && imageRef.current.click()}
          >
            {btnText}
          </button> */}
        </>
      )}
    </div>
  );
};

export default NewTicketImageTemp;
